import { ImportState } from './imports.reducer';

export const selectImportProducts = (state: ImportState) =>
  state.importProducts;
export const selectImportErrors = (state: ImportState) => state.errors;
